(() => {
'use strict';
// Papá Noel Luz en Shopify (tema 10x, layout landing). Las opciones de cantidad (Quantity Offers),
// la variante de cada unidad y el botón PAGA AL RECIBIR los pinta Releasit dentro de #papa-noel-luz-cod-form.
// Base: assets/landing-shopify.js del skill landing-a-shopify. Lo propio de esta landing va al final.
const SLUG = 'papa-noel-luz';
const variants = window.LandingVariants || {};

const RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];
function findReleasitButton() {
  for (const selector of RELEASIT_SELECTORS) {
    const el = document.querySelector(selector);
    if (el) return el;
  }
  return null;
}

// Cuando Releasit inserta su botón en el form, se oculta el CTA de respaldo.
const codForm = document.getElementById(`${SLUG}-cod-form`);
function markReleasitReady() {
  if (codForm && codForm.querySelector('button, a, .rsi-btn-skel')) document.body.classList.add(`${SLUG}-rsi-ready`);
}
if (codForm) {
  new MutationObserver(markReleasitReady).observe(codForm, {childList:true, subtree:true});
  markReleasitReady();
}

// Variantes que NO se venden en esta landing (ej. PlegaPino: /90\s*CM|RGB/i). null = ninguna.
// Solo ocultar opciones: no cambiar por script la variante de otras unidades (en Mundo Épico eso
// hizo que Releasit sumara unidades de más al pedido). Probar siempre el modal después.
const EXCLUDED_VARIANT = null;
if (EXCLUDED_VARIANT) {
  const setSelectValue = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  const clean = () => document.querySelectorAll('[class*="rsi"] select, [id*="rsi"] select').forEach(select => {
    let firstAllowed = null;
    [...select.options].forEach(option => {
      if (EXCLUDED_VARIANT.test(option.text)) { option.hidden = true; option.disabled = true; }
      else if (!firstAllowed) firstAllowed = option;
    });
    const current = select.options[select.selectedIndex];
    if (firstAllowed && current && EXCLUDED_VARIANT.test(current.text)) {
      setSelectValue.call(select, firstAllowed.value);
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
  new MutationObserver(clean).observe(document.body, {childList:true, subtree:true});
  clean();
}

const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
function goToOffer(event) {
  if (event) event.preventDefault();
  const anchor = document.getElementById(`${SLUG}-order-anchor`) || document.body;
  anchor.scrollIntoView({behavior:reduceMotion(), block:'center'});
}
// CTA de respaldo (solo visible si Releasit no cargó su botón)
document.querySelectorAll('[data-order-fallback]').forEach(button => button.addEventListener('click', () => {
  const releasitButton = findReleasitButton();
  if (releasitButton) { releasitButton.click(); return; }
  if (!variants.first) return;
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(variants.first), quantity:1}]})})
    .then(response => { if (!response.ok) throw new Error('cart'); window.location.href = '/cart'; })
    .catch(() => {});
}));
// Todos los CTA de la página llevan a la oferta (ahí vive Releasit)
document.querySelectorAll('[data-order]').forEach(link => link.addEventListener('click', goToOffer));

// Imágenes que falten muestran su código en vez del ícono roto (patrón .ph / .miss)
document.querySelectorAll('.ph img').forEach(img => {
  const mark = () => img.closest('.ph').classList.add('miss');
  if (img.complete && !img.naturalWidth) mark(); else img.addEventListener('error', mark);
});

// Barra fija: aparece al pasar la oferta y se oculta en el cierre (#pedir o .final)
const sticky = document.getElementById('sticky');
const offer = document.getElementById(`${SLUG}-order-anchor`);
const finalSec = document.getElementById('pedir') || document.querySelector('.final');
if (sticky && offer) {
  let pastOffer = false, nearFinal = false;
  const update = () => {
    const show = pastOffer && !nearFinal;
    sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
  };
  new IntersectionObserver(([e]) => { pastOffer = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(offer);
  if (finalSec) new IntersectionObserver(([e]) => { nearFinal = e.isIntersecting; update(); }).observe(finalSec);
}

// ---------- Propio de esta landing (galería, antes/después, carruseles…) ----------
// Copiar aquí desde el <script> de la landing local SOLO lo que no dependa del selector de packs,
// del formulario de prueba o del modal (eso ya no existe en Shopify).
// Galería del hero (las miniaturas traen data-src + data-srcset del WebP)
const mainImg = document.getElementById('mainImg'), mainPh = document.getElementById('mainPh');
const thumbs = [...document.querySelectorAll('.thumb')];
thumbs.forEach(t => t.addEventListener('click', () => {
  thumbs.forEach(x => x.setAttribute('aria-pressed', x === t));
  mainPh.classList.remove('miss'); mainPh.dataset.code = t.dataset.code;
  mainImg.srcset = t.dataset.srcset || ''; mainImg.src = t.dataset.src; mainImg.alt = t.dataset.alt;
}));

// Videos: avanzan solos cada 4 s, se pausan al tocar; solo reproduce los que se ven
const track = document.getElementById('reels'), dots = document.getElementById('reelsDots');
if (track && dots) {
  const reels = [...track.querySelectorAll('.reel')];
  let cur = 0, timer = null, paused = false;
  const go = i => { cur = (i + reels.length) % reels.length; track.scrollTo({left: reels[cur].offsetLeft - (track.clientWidth - reels[cur].clientWidth) / 2, behavior: 'smooth'}); };
  const mark = () => { const mid = track.scrollLeft + track.clientWidth / 2; let best = 0, d = 1e9; reels.forEach((r, i) => { const c = Math.abs(r.offsetLeft + r.clientWidth / 2 - mid); if (c < d) { d = c; best = i; } }); cur = best; [...dots.children].forEach((b, i) => b.setAttribute('aria-current', i === cur)); };
  const start = () => { clearInterval(timer); if (!paused && !matchMedia('(prefers-reduced-motion:reduce)').matches) timer = setInterval(() => go(cur + 1), 4000); };
  const hold = () => { paused = true; clearInterval(timer); clearTimeout(hold.t); hold.t = setTimeout(() => { paused = false; start(); }, 8000); };
  reels.forEach((r, i) => { const b = document.createElement('button'); b.setAttribute('aria-label', 'Video ' + (i + 1)); b.addEventListener('click', () => { go(i); hold(); }); dots.appendChild(b); });
  track.addEventListener('scroll', () => { clearTimeout(mark.t); mark.t = setTimeout(mark, 80); }, {passive: true});
  ['touchstart', 'pointerdown', 'wheel'].forEach(ev => track.addEventListener(ev, hold, {passive: true}));
  const vio = new IntersectionObserver(es => es.forEach(e => { const v = e.target; if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }), {threshold: .5});
  reels.forEach(r => vio.observe(r.querySelector('video')));
  mark(); start();
}

// Antes / después
const ba = document.getElementById('ba');
if (ba) ba.querySelector('input').addEventListener('input', e => ba.style.setProperty('--pos', e.target.value + '%'));

})();
